// extracted by mini-css-extract-plugin
export var aircallIframe = "_m2-3";
export var fabContainer = "_m2-5";
export var fabRinging = "_m2-6";
export var loadingOverlay = "_m2-4";
export var pulse = "_m2-7";
export var widgetContent = "_m2-2";
export var widgetPanel = "_m2-0";
export var widgetPanelExpanded = "_m2-1";